import requestor from "../../requestor";

export default class ItemApi {
  all = (page = 1, filter = {}, sort = {}) =>
    requestor.get("/item/all", {
      page: page,
      filter: filter,
      sort: sort,
    });
  autocomplete = (query, page = 1, limit = 10) =>
    requestor.get("/item/autocomplete", { query: query, page: page, limit: limit });
  one = (id) => requestor.get("/item/one", { id: id });
  getClients = (id) => requestor.get("/item/clients_all", { id: id });
  revokeFree = (client_id, item_id) =>
    requestor.delete("/item/revoke_free", { client_id: client_id, item_id: item_id });
  create = (form) => requestor.post("/item/create", form);
  save = (form) => requestor.patch("/item/save", { Item: form });
  delete = (id) => requestor.post("/item/delete", { id: id });
  copy = (id) => requestor.put("/item/copy", { id: id });
  remove = (id) => requestor.delete("/item/delete", { id: id });
  toggle = (id) => requestor.patch("/item/toggle", { id: id });
  preview = (id) => requestor.get("/item/preview", { id: id });
  hasRecurringOrder = (id) => requestor.get("/item/has_recurring_order", { id: id });
}
